"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _useCombineRef = _interopRequireDefault(require("../hooks/useCombineRef"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Typography = (0, _react.forwardRef)(function (_ref, ref) {
  var _classnames;

  var Component = _ref.tag,
      color = _ref.color,
      emphasys = _ref.emphasys,
      children = _ref.children,
      className = _ref.className,
      modifier = _ref.modifier,
      html = _ref.html,
      otherProps = _objectWithoutProperties(_ref, ["tag", "color", "emphasys", "children", "className", "modifier", "html"]);

  var innerRef = (0, _react.useRef)(null);
  var combinedRef = (0, _useCombineRef.default)(ref, innerRef);
  var classes = (0, _classnames2.default)(className, 'ea-typography', (_classnames = {
    'ea-typography--content': html,
    'ea-typography--emphasys': emphasys
  }, _defineProperty(_classnames, "ea-typography--".concat(modifier), modifier), _defineProperty(_classnames, "et-".concat(color === 'accent' ? '' : 'text-').concat(color), color), _classnames));

  var props = _objectSpread({}, otherProps, {
    className: classes
  });

  if (html) {
    props.dangerouslySetInnerHTML = {
      __html: html
    };
  }

  return _react.default.createElement(_react.default.Fragment, null, !children ? _react.default.createElement(Component, _extends({}, props, {
    ref: combinedRef
  })) : _react.default.createElement(Component, _extends({}, props, {
    ref: combinedRef
  }), children));
});
Typography.propTypes = {
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  color: _propTypes.default.oneOf(['dark-low', 'dark-medium', 'dark-high', 'light-high', 'light-solid', 'accent']),
  emphasys: _propTypes.default.bool,
  html: _propTypes.default.string,
  modifier: _propTypes.default.oneOf(['display', 'heading-l', 'heading-m', 'heading-s', 'heading-xs', 'subheading', 'body-m', 'body-p', 'caption']),
  tag: _propTypes.default.string
};
Typography.defaultProps = {
  children: null,
  className: '',
  color: 'dark-medium',
  emphasys: false,
  html: null,
  tag: 'p'
};
Typography.displayName = 'Typography';
var _default = Typography;
exports.default = _default;